<script>
  import { fly } from "svelte/transition";
  import { tourFunctions } from "../tour-functions";

  export let width;
  export let linkto;
  export let click;
  export let image;
  export let opacity = 1;

  image = image || "./images/logo.png";

  function onclick() {
    if (click) click();
    if (linkto && linkto.length != "") window.open(linkto, "_blank");
    else tourFunctions.loadFirstScene('logo');
    
    tourFunctions.focus();
  }
</script>

<button
  on:click={onclick}
  transition:fly={{ y: -300, duration: 500 }}
  tabindex="0"
>
  <img
    style={`opacity: ${opacity};`}
    src={image}
    {width}
    alt={linkto ? "Go to our website" : "Load the starting scene"}
  />
</button>
{#if process.env.NODE_ENV === "development"}
  <div class="guide" style={`left: ${20 + width / 2}px`}></div>
  <div class="guide" style={`left: ${20 + width}px`}></div>
  <div class="guide" style={`left: ${20}px`}></div>
{/if}

<style>
  .guide {
    height: 100%;
    width: 1px;
    background: red;
    position: absolute;
    z-index: 999;
    top: 0;
  }

  button {
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 750;
    cursor: pointer;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
  }

  img {
    height: auto;
  }
</style>
